<div id="credito-medico" class="container-requests">
  <div *ngIf="isAdmin || superAdmin" >
    <p class="copec-rg-20" style="line-height: 34px">Revisa la solicitud</p>
    <p class="copec-lg-16 colorgray" style="line-height: 26px">
      Revisa cuidadosamente esta solicitud.
    </p>
  </div>
  <div
    class="box-summary"
    [ngStyle]="{ heigth: correctionMedicalCredit ? '1129px' : '1087px' }"
  >
    <div class="box-summarytitle">
      <p class="copec-rg-20 title-summary">Información de la solicitud</p>
      <img id="summ-img-2" [src]="getIconStatusMedicalCredit()" alt="" style="height: 24px" />
    </div>
    <div *ngIf=" selectedOption === 'Enviada' && titular.bono === 'BONP' ">
      <p class="copec-lg-16" style="line-height: 26px; margin-left:16px; margin-bottom: 0px; ">
        <img
                src="./assets/icon-summary/warning.svg"
                alt=""
              />La solicitud debe contar con documentos adjuntos para ser respondida</p>
    </div>
    <div class="copec-lg-16 box-dataform">
      <table class="info-personal" id="summary-credit" [ngStyle]="{'margin-left': selectedOption === 'Con error' ? '22px': '0px'}">
          <caption></caption>
          <div>
              <tr>
                  <th id="personal-inf" class="copec-bold-16 subtitleForm">
                      Información personal</th>
              </tr>
                <tr><td class="colorgray">Nombre Titular</td><td>{{ titular.nombre }}</td></tr>      
                <tr><td class="colorgray">RUT Titular:</td><td>{{ titular.rut }}</td></tr>
                <tr><td class="colorgray">Email Corporativo:</td><td>{{ titular.email }}</td></tr> 
                <tr><td class="colorgray">Tipo Movimiento:</td><td>{{ titular.bono }}</td></tr>        
              </div>

          </table>
          <p id="beneficiarie" class="copec-bold-16 subtitleForm" 
          >Información Beneficiarios
            </p>
          <table id="tabla-beneficiarios" class="tabla-beneficiarios" aria-describedby="tab-beneficiarios">
            <thead>
              <tr class=" copec-rg-14 colorgray" >
                <th>Nombre Beneficiario</th>
                <th>Folio Documento</th>
                <th>Monto Prestación</th>
                <th>Monto Bonificación</th>
                <th>Monto Copago</th>
                <th>Fecha Emisión</th>
              </tr>
            </thead>
            <tbody >
              <tr class="copec-rl-14" *ngFor="let beneficiario of beneficiarios">
                <td>{{ beneficiario['Nombre Beneficiario'] }}</td>
                <td>{{ beneficiario['Folio Documento'] }}</td>
                <td>{{ beneficiario['Monto Prestación'] }}</td>
                <td>{{ beneficiario['Monto Bonificación'] }}</td>
                <td>{{ beneficiario['Monto Copago'] }}</td>
                <td>{{ beneficiario['Fecha Emisión'] }}</td>
              </tr>
            </tbody>
          </table>

          <div *ngIf="this.seccionArchivosVisible">
          <app-download-file
          [summaryData_archivos]="archivos"
          [statusRequest]="selectedOption"
          [correction]="correctionMedicalCredit"
          ></app-download-file>
        </div>

  </div>
    <div
      class="button-option"
      *ngIf="selectedOption !== 'Aprobada' && selectedOption !== 'Rechazada'"
    >
      <button
        class="copec-rg-16 correct"
        *ngIf="isAdmin || superAdmin" 
        (click)="buttonCorrectMedicalCredit()"
        [ngStyle]="{ width: correctionMedicalCredit ? '185px' : '144px' }"
        [disabled]="!seccionArchivosVisible && titular.bono === 'BONP' "
      >
        {{ " Está correcto" }}
      </button>
    </div>
  </div>
</div>

<div class="modals">
    <div class="modalapproved" *ngIf="openModalApprovedMedicalCredit">
      <app-modal-approved
        (closeModalPlan)="closeModalMedicalCredit($event)"
        (nextStatus)="savedApprobedMedicalCredit($event)"
      ></app-modal-approved>
    </div> 
</div>
<div *ngIf="spinner">
  <app-spinner></app-spinner>
</div>